import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requests from 'app/requests/OpportunityForecast.requests'
import {
    ForecastOngoingOpportunities,
} from '../Forecast.types'

const useGetForecast = (id: number) => {
    return useRequest<ForecastOngoingOpportunities>({
        key: RequestKeys.getForecastById,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requests.get),
        enabled: Boolean(id),
    })
}

export default useGetForecast
